import React, { Component } from 'react';
import { connect } from "react-redux";
import 'react-bootstrap';

import blogApi from "../../../api/blogApi";
import store from '../../../store/configureStore';
import Pagination from '../../../components/pagination/Pagination';
import NoData from '../../../components/NoData';
import BlogBlock from './BlogBlock';
import { addNotification } from "../../../actions/notificationAction";
import { Businesses } from '../../../config/Helper';
import { lang } from '../../../config/lang';
import $ from "jquery/dist/jquery.js";
import { withRouter } from 'react-router-dom';


class BlogListMain extends Component {

    constructor(props) {
        super(props);
        this.state = {
            arrBlog: [],
            curPage: 1,
            pages: 1,
            perPage: 6,
            isPage: false,
            total: 0
        }
        this.isLoading = true;
        this.search_key = this.props.search_key;
        this.category = this.props.category;
        this.subCate = this.props.subCate;
        this.isCategory = this.props.isCategory;
        this.getBlogs = this.getBlogs.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
    }

    componentWillMount() {

    }

    componentDidMount() {
        const search = this.props.history.location.search.split('?');
        let queryParams;

        if (search.length > 1) {
            const query = search[1].split('=');

            if (query.length) {
                queryParams = { [query[0]]: parseInt(query[1]) };
                this.setState({ curPage: queryParams.page });

            }
        }
        this.perPage = $('#perpage_blog_selector').val()
        this.getBlogs(false, queryParams && queryParams.page ? queryParams.page : this.state.curPage);
        // if (this.props.curPage) this.setState({ curPage: this.props.curPage });
        // this.getBlogs(true);

    }

    componentWillUnmount() {

    }

    componentDidUpdate() {
        window.playVideo();
    }

    componentWillReceiveProps(newProps) {
        if (this.props.language.lang_key !== newProps.language.lang_key
            || this.search_key !== newProps.search_key
            || this.category !== newProps.category
            || this.subCate !== newProps.subCate
            || this.isCategory !== newProps.isCategory) {

            if (this.props.language.lang_key === newProps.language.lang_key
                && (this.search_key !== newProps.search_key
                    || this.category !== newProps.category
                    || this.subCate !== newProps.subCate
                    || this.isCategory !== newProps.isCategory)) {

                // eslint-disable-next-line
                this.state.curPage = 1;
            }

            this.search_key = newProps.search_key;
            this.category = newProps.category;
            this.subCate = newProps.subCate;
            this.isCategory = newProps.isCategory;
            if (newProps.isCategory) this.state.isPage = false;
        }
        // this.setState({ curPage: 1 });
        const search = this.props.history.location.search.split('?');
        let queryParams;

        if (search.length > 1) {
            const query = search[1].split('=');
            if (query.length) {
                queryParams = { [query[0]]: parseInt(query[1]) };
                this.setState({ curPage: queryParams.page });
            }
        }
        this.perPage = $('#perpage_blog_selector').val();

        this.getBlogs(true, queryParams && queryParams.page ? (this.isCategory ? (this.state.isPage ? queryParams.page : 1) : queryParams.page) : this.state.curPage);
    }

    getBlogs(willGoTop, curPage) {
        this.isLoading = true;
        var business = this.category < 0 ? '' : Businesses[this.category];
        blogApi.getBlogsWithPage(curPage, business, this.subCate === 0 ? '' : this.subCate, this.search_key, 'o', '', this.perPage).then((json) => {
            if (json.status === 200) {
                this.isLoading = false;
                this.setState({
                    arrBlog: json.data.data,
                    curPage: json.data.currentPage > json.data.total ? 1 : json.data.currentPage,
                    pages: json.data.lastPage,
                    total: json.data.total
                });

                window.contentWayPoint();
                // willGoTop && window.scrollTop('#blog_main_section');
            } else {
                store.dispatch(addNotification(`${lang('server_err')}`, 'error'));
            }
        })
    }

    onChangePage(page) {
        // eslint-disable-next-line
        this.state.curPage = page;
        this.state.isPage = true;
        this.props.history.push("/blog" + "?" + "page=" + page);

        this.getBlogs(true, page); // will go to top

    }
    render() {
        var visible = 6;
        return (
            <div className="row">
                <section style={{ width: '100%' }}>
                    <div className="container">
                        <div className="row flex-column align-items-center pb-5">
                            <div className="mt-3 mb-3">
                            {`${lang('total')}` + this.state.total}
                            </div>
                            <div className="block-27">
                                {
                                    this.state.arrBlog.length > 0 &&
                                    <Pagination
                                        total={this.state.pages}
                                        curPage={this.state.curPage}
                                        visible={visible}
                                        onChangePage={(page) => this.onChangePage(page)}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </section>
                <div className="col-md-12">
                    {
                        this.state.arrBlog.map((blog, key) => (
                            <BlogBlock
                                curBusiness={Businesses[this.category]}
                                currentPage={this.state.curPage}
                                key={key}
                                business={blog.business}
                                id={blog.id}
                                title={blog.title}
                                description={blog.description}
                                created_at={blog.created_at}
                                image={blog.media_filename}
                                media_type={blog.media_filetype}
                                keyword={this.search_key}
                            />

                        ))
                    }
                </div>

                <section style={{ width: '100%' }}>
                    <div className="container">
                        <div className="row justify-content-center pb-5">
                            <div className="block-27">
                                {
                                    this.state.arrBlog.length > 0 &&
                                    <Pagination
                                        total={this.state.pages}
                                        curPage={this.state.curPage}
                                        visible={visible}
                                        onChangePage={(page) => this.onChangePage(page)}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        language: state.language
    };
}

export default withRouter(connect(mapStateToProps)(BlogListMain));